require('./mortgageRequestCostWafer.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
const classNames = require('classnames');
// @helper
const { formatText, hasTranslation } = require('core/i18n').i18n;

const MortgageRequestCostWafer = props => {
    const { title, text, amount, label, hasFootNote, footNote, className } = props;
    const waferClasses = classNames(className, 'mortgage-request-cost-wafer');

    let finalTitle, finalText, finalLabel, finalFootnote, footNoteContent;

    if (hasTranslation(title)){
        finalTitle = formatText(title);
    } else {
        finalTitle = title;
    }

    if (hasTranslation(text)) {
        finalText = formatText(text);
    } else {
        finalText = text;
    }

    if (hasTranslation(label)) {
        finalLabel = formatText(label);
    } else {
        finalLabel = label;
    }

    if (hasFootNote) {
        if (hasTranslation(footNote)) {
            finalFootnote = formatText(footNote);
        } else {
            finalFootnote = footNote;
        }

        footNoteContent = (
            <div className="mortgage-request-cost-wafer__total-cost--foot-note">
                {finalFootnote}
            </div>
        )
    }

    return (
        <div className={waferClasses}>
            <div className="mortgage-request-cost-wafer__section mortgage-request-cost-wafer__section--info">
                <div className="mortgage-request-cost-wafer__info">
                    <div className="mortgage-request-cost-wafer__info--title">
                        {finalTitle}
                    </div>
                    <div className="mortgage-request-cost-wafer__info--text">
                        {finalText}
                    </div>
                </div>
            </div>
            <div className="mortgage-request-cost-wafer__section mortgage-request-cost-wafer__section--total-cost">
                <div className="mortgage-request-cost-wafer__total-cost">
                    <div className="mortgage-request-cost-wafer__total-cost--amount">
                        {amount}
                    </div>
                    <div className="mortgage-request-cost-wafer__total-cost--label">
                        {finalLabel}
                    </div>
                    {footNoteContent}
                </div>
            </div>
        </div>
    );
};

MortgageRequestCostWafer.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    label: PropTypes.string.isRequired,
    hasFootNote: PropTypes.bool,
    footNote: PropTypes.string,
    className: PropTypes.string
};

module.exports = MortgageRequestCostWafer;